export default __webpack_public_path__ + "static/media/momo.1400aa7d.svg";